const KEYS = {
  TOKEN: "apiToken",
  COMPANY_ID: "companyId",
  STAFF_TOKEN_BACKUP: "staff_apiToken_backup",
  STAFF_COMPANY_BACKUP: "staff_companyId_backup",
  IMPERSONATION_ACTIVE: "impersonation",
  IMPERSONATION_COMPANY_ID: "impersonation_company_id",
  IMPERSONATION_EXPIRES_AT: "impersonation_expires_at",
};

const listeners = new Set();

const notify = () => listeners.forEach((cb) => cb());

const writeRaw = (key, value) => {
  if (value === null || value === undefined || value === "") {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.setItem(key, String(value));
  }
  notify();
};

const readRaw = (key) => {
  const raw = sessionStorage.getItem(key);
  if (raw === null || raw === undefined || raw === "" || raw === "null") {
    return null;
  }
  return raw;
};

export const subscribeSession = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export const getCompanyId = () => readRaw(KEYS.COMPANY_ID);
export const getCompanyIdNumber = () => {
  const v = readRaw(KEYS.COMPANY_ID);
  return v === null ? null : Number(v);
};
export const setCompanyId = (id) => writeRaw(KEYS.COMPANY_ID, id);
export const clearCompanyId = () => writeRaw(KEYS.COMPANY_ID, null);

export const getToken = () => readRaw(KEYS.TOKEN);
export const setToken = (token) => writeRaw(KEYS.TOKEN, token);
export const clearToken = () => writeRaw(KEYS.TOKEN, null);
export const hasToken = () => getToken() !== null;

export const getStaffBackup = () => ({
  token: readRaw(KEYS.STAFF_TOKEN_BACKUP),
  companyId: readRaw(KEYS.STAFF_COMPANY_BACKUP),
});

export const setStaffBackup = ({ token, companyId }) => {
  writeRaw(KEYS.STAFF_TOKEN_BACKUP, token);
  writeRaw(KEYS.STAFF_COMPANY_BACKUP, companyId);
};

export const clearStaffBackup = () => {
  writeRaw(KEYS.STAFF_TOKEN_BACKUP, null);
  writeRaw(KEYS.STAFF_COMPANY_BACKUP, null);
};

export const getImpersonation = () => {
  const expiresRaw = readRaw(KEYS.IMPERSONATION_EXPIRES_AT);
  return {
    active: readRaw(KEYS.IMPERSONATION_ACTIVE) === "1",
    companyId: readRaw(KEYS.IMPERSONATION_COMPANY_ID),
    expiresAt: expiresRaw === null ? 0 : parseInt(expiresRaw, 10),
  };
};

export const setImpersonation = ({ companyId, expiresAt }) => {
  writeRaw(KEYS.IMPERSONATION_ACTIVE, "1");
  writeRaw(KEYS.IMPERSONATION_COMPANY_ID, companyId);
  writeRaw(KEYS.IMPERSONATION_EXPIRES_AT, expiresAt);
};

export const clearImpersonation = () => {
  writeRaw(KEYS.IMPERSONATION_ACTIVE, null);
  writeRaw(KEYS.IMPERSONATION_COMPANY_ID, null);
  writeRaw(KEYS.IMPERSONATION_EXPIRES_AT, null);
};

export const clearAllSession = () => {
  sessionStorage.clear();
  notify();
};

export const buildCompanyParams = (extra = {}) => {
  const params = new URLSearchParams({ company_id: getCompanyId() || "" });
  Object.entries(extra).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    params.set(k, String(v));
  });
  return params;
};
